import serverCall from "../../serverCall";

const login = (payload) => {
  try {
    const response = serverCall.post(`/auth/login-admin`, payload);
    return response;
  } catch (error) {
    throw error;
  }
};

const signup = (email, password) => {
  try {
    const response = serverCall.post(
      `/auth/signUp?email=${email}&password=${password}&signUpType=ADMIN`
    );
    return response;
  } catch (error) {
    throw error;
  }
};

const AuthService = {
  login,
  signup,
};

export default AuthService;
